export type DispatchStatus = 'valid' | 'invalid' | 'canceled';

export type DispatchesFilters = {
  region_id?: number;
  date?: string;
  query?: string;
  status?: DispatchStatus;
};

export const parseIdParam = (value: string | null): number | undefined => {
  if (!value || !/^\d+$/.test(value)) {
    return undefined;
  }
  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export const isDispatchStatus = (value: string): value is DispatchStatus =>
  value === 'valid' || value === 'invalid' || value === 'canceled';

export const parseFiltersFromSearch = (search: string): DispatchesFilters => {
  const params = new URLSearchParams(search);
  const filters: DispatchesFilters = {};

  const regionID = parseIdParam(params.get('region_id'));
  if (regionID !== undefined) {
    filters.region_id = regionID;
  }

  const date = params.get('date');
  if (date) {
    filters.date = date;
  }

  const query = params.get('query');
  if (query) {
    filters.query = query;
  }

  const status = params.get('status');
  if (status && isDispatchStatus(status)) {
    filters.status = status;
  }

  return filters;
};

export const cleanupFilters = (filters: DispatchesFilters): Record<string, string | number> => {
  const results: Record<string, string | number> = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      results[key] = value;
    }
  });

  return results;
};

export const syncFiltersToUrl = (filters: DispatchesFilters) => {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams();

  Object.entries(cleanupFilters(filters)).forEach(([key, value]) => {
    searchParams.set(key, String(value));
  });

  url.search = searchParams.toString();
  window.history.replaceState({}, '', url.toString());
};
